import { App } from './components/App';
import { Root, createRoot, hydrateRoot } from 'react-dom/client';
import React from 'react';
import 'core-js/proposals/relative-indexing-method';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

const container: HTMLElement | null = document.getElementById('app');

if (container) {
  const root: Root = container?.hasChildNodes() ? hydrateRoot(container, <App />) : createRoot(container);
  root.render(<App />);
}
